import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom'
import UserProfile from './pages/UserProfile';

const App = () => {
  return (
    <Routes>
      <Route path="/profile/:cardUrl" element={<UserProfile />} />
    </Routes>
  );
};

export default App;
